module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_3@2x-92fc5af37d92d815cbb9659033bb423b.png";